import gql from 'graphql-tag';

export const getUnitStatuses = gql`
  query getUnitStatuses($aorId: String) {
    getUnitStatuses(aorId: $aorId) {
      id
      name
    }
  }
`;
